import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";

type PropsDef = {
  coachId: string;
  onClick: (coachId: string, event: React.MouseEvent) => void;
};

/**
 * The gear button of a coach column header.
 *
 * A click opens the calendar settings of that coach. The Coaches view and the
 * Resources view both use this button.
 */
export default function CoachSettingsButton({ coachId, onClick }: PropsDef) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={styles.coach_settings_button}
      onClick={(event) => onClick(coachId, event)}
      title={t("Calendar Settings")}
    >
      <i className="ico ico-cog" />
    </button>
  );
}
